import React, { useReducer, useContext, useEffect } from "react";
import CryptoContext from "./cryptoContext";
import CryptoReducer from "./cryptoReducer";
import ParameterContext from "../parameter/parameterContext";
import axios from "axios";
import { socket } from "../../services/socket";
import { formatDate } from "../../helpers/format";

import {
  GET_GLOBAL_TICKER,
  GET_GLOBAL_TICKER_ERROR,
  SORT_GLOBAL_TICKER_BY_PRICE,
  SORT_GLOBAL_TICKER_BY_24H,
  SORT_GLOBAL_TICKER_BY_7D,
  SORT_GLOBAL_TICKER_BY_NAME,
  SORT_GLOBAL_TICKER_BY_RANK,
  SORT_GLOBAL_TICKER_BY_MARKET_CAP,
  SORT_GLOBAL_TICKER_BY_VOLUME_IN_24H,
  SEARCH_COINS,
  GET_SINGLE_CRYPTO_DETAILS_ERROR,
  GET_SINGLE_CRYPTO_DETAILS,
  CLEAR_SINGLE_CRYPTO_DETAILS,
  START_LOADING,
  STOP_LOADING,
  GET_ALL_CRYPTO_COINS,
  GET_COMPARE_CRYPTO_COIN_DATA1,
  GET_COMPARE_CRYPTO_COIN_DATA2,
  SET_COMPARE_CRYPTO_COIN_DATA1,
  SET_COMPARE_CRYPTO_COIN_DATA2,
  GET_FAVOURITE_CRYPTO_COINS,
  GET_NAMES_OF_DISPLAYED_CRYPTO_COINS,
  SET_CONVT,
  GET_CRYPTO_COINS_SPARKLINES,
  SET_CRYPTOSTR,
  CLEAR_SPARKLINES,
  GET_SINGLE_CRYPTO_COINS_SPARKLINES,
  GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE,
  GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE,
  SET_LIVE_PRICE,
  GET_EXCHANGE_RATE,
  GET_FAVOURITE_CRYPTO_COINS_SPARKLINES,

  SORT_NORMALLY,
} from "../types";
import dotenv from "dotenv";
dotenv.config();
const getCurrencyDetailsFromLocalStorage = localStorage.getItem(
  "currencyDetails"
)
  ? JSON.parse(localStorage.getItem("currencyDetails"))
  : { convt: "USD", exchangeRate: 1, currencySymbol: "$" };

const CryptoState = ({ children }) => {
  const initialState = {
    cryptoData: null,
    convt: getCurrencyDetailsFromLocalStorage.convt,
    cryptoDataError: null,
    order: 2,
    filter: false,
    filteredCryptoData: null,
    singleCryptoData: [],
    allCoinsData: null,
    filteredSearchData: null,
    cryptoCoinData1: "BTC",
    cryptoCoinData2: "ETH",
    compareCryptoCoinData1: null,
    compareCryptoCoinData2: null,
    headerCoins: null,
    favouriteCryptoCoins: null,
    cryptoStr: null,
    sparklineData: null,
    singleSparklineData: null,
    compareCryptoCoinData1Sparkline: null,
    compareCryptoCoinData2Sparkline: null,
    singleCryptoPrice: 0,
    livePriceData: null,
    exchangeRate: getCurrencyDetailsFromLocalStorage.exchangeRate,
    favouriteSparklineData: null,
    currencySymbol: getCurrencyDetailsFromLocalStorage.currencySymbol,
  };
  const [state, dispatch] = useReducer(CryptoReducer, initialState);
  const { page, timeInChart } = useContext(ParameterContext);

  useEffect(() => {
    socket.on("top100CoinsPrice", (data) => {
      dispatch({ type: SET_LIVE_PRICE, payload: data });
    });

    // unsubscribe from event for preventing memory leaks
    return () => {
      socket.close();
    };
  }, []);

  useEffect(() => {
    // }
  }, []);

  useEffect(() => {
    getExchangeRate();
    //eslint-disable-next-line
  }, [state.convt]);

  const getGlobalTicker = (pageNo = page + 1, convt = state.convt) => {
    dispatch({ type: START_LOADING });
    // if(!state.cryptoData||!state.cryptoData.length > 0){
    socket.emit("coinPerPage", { pageNo: page + 1, limit: 100 });
    socket.on("coinPerPageResponse", (data) => {
      dispatch({ type: GET_GLOBAL_TICKER, payload: data });

      socket.emit("sparkLineData", {
        timeFrame: "7dSparkline",
        coins: data.map((d) => d.id).join(","),
        single: false,
      });
      socket.on("sparkLineDataResponse", (sparkdata) => {
        dispatch({ type: GET_CRYPTO_COINS_SPARKLINES, payload: sparkdata });
      });

      dispatch({ type: STOP_LOADING });
    });
  };
  const sortGlobalTickerByPrice = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_PRICE, payload: p });
    }
  };
  const sortGlobalTickerBy24h = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_24H, payload: p });
    }
  };
  const sortGlobalTickerBy7d = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_7D, payload: p });
    }
  };
  const sortGlobalTickerByName = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_NAME, payload: p });
    }
  };
  const sortGlobalTickerByRank = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_RANK, payload: p });
    }
  };
  const sortGlobalTickerByMarketCap = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_MARKET_CAP, payload: p });
    }
  };
  const sortGlobalTickerByVolumeIn24h = (p = 1) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SORT_GLOBAL_TICKER_BY_VOLUME_IN_24H, payload: p });
    }
  };
  const searchCoins = (formData) => {
    if (state.cryptoData && state.cryptoData.length > 0) {
      dispatch({ type: SEARCH_COINS, payload: formData });
    }
  };
  const getSingleCryptoDetails = async (id) => {
    dispatch({ type: START_LOADING });
    try {
      // const { data } = await axios.get(
      //   `https://api.nomics.com/v1/currencies/ticker?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${id}&interval=1d&convert=${convt}`
      // );
      socket.emit("coinData", { cid: id ? id : "BTC" });
      socket.on("coinDataResponse", (singleData) => {
        dispatch({
          type: GET_SINGLE_CRYPTO_DETAILS,
          payload: [JSON.parse(singleData)],
        });
        dispatch({ type: STOP_LOADING });
      });
    } catch (err) {
      dispatch({
        type: GET_SINGLE_CRYPTO_DETAILS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const clearSingleCryptoDetails = () => {
    dispatch({ type: CLEAR_SINGLE_CRYPTO_DETAILS });
  };
  const getAllCryptoCoins = async (convt = state.convt) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await axios.get(
        `https://api.nomics.com/v1/currencies?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&attributes=id,name,logo_url&convert=${convt}`
      );

      dispatch({ type: GET_ALL_CRYPTO_COINS, payload: data });
      dispatch({ type: STOP_LOADING });
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getCompareCryptoCoinData1 = async (id, convt = state.convt) => {
    try {
      dispatch({ type: START_LOADING });
      // const { data } = await axios.get(
      //   `https://api.nomics.com/v1/currencies/ticker?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${id}&interval=1d&convert=${convt}`
      // );
      dispatch({ type: SET_COMPARE_CRYPTO_COIN_DATA1, payload: id });
      dispatch({
        type: GET_COMPARE_CRYPTO_COIN_DATA1,
        payload:
          state.cryptoData &&
          state.cryptoData.length > 0 &&
          state.cryptoData.filter((d) => d.id === id),
      });
      // dispatch({
      //   type: GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE,
      //   payload: state.sparklineData&&state.sparklineData.length>0&&state.sparklineData.filter(d=>d.id===id),
      // });

      dispatch({ type: STOP_LOADING });
    } catch (err) {
      dispatch({
        type: GET_SINGLE_CRYPTO_DETAILS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getCompareCryptoCoinData2 = async (id, convt = state.convt) => {
    try {
      dispatch({ type: START_LOADING });
      // const { data } = await axios.get(
      //   `https://api.nomics.com/v1/currencies/ticker?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${id}&interval=1d&convert=${convt}`
      // );

      dispatch({ type: SET_COMPARE_CRYPTO_COIN_DATA2, payload: id });
      dispatch({
        type: GET_COMPARE_CRYPTO_COIN_DATA2,
        payload:
          state.cryptoData &&
          state.cryptoData.length > 0 &&
          state.cryptoData.filter((d) => d.id === id),
      });
      // dispatch({
      //   type: GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE,
      //   payload: state.sparklineData&&state.sparklineData.length>0&&state.sparklineData.filter(d=>d.id===id),
      // });

      dispatch({ type: STOP_LOADING });
    } catch (err) {
      dispatch({
        type: GET_SINGLE_CRYPTO_DETAILS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const setConvt = (currency) => {
    dispatch({ type: SET_CONVT, payload: currency });
  };

  const getFavouriteCryptoCoins = async (favouriteCrypto) => {
    try {
      // const { data } = await axios.get(
      //   `https://api.nomics.com/v1/currencies/ticker?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&interval=1d,7d&ids=${
      //     coinString.length > 0 ? coinString : "1"
      //   }`
      // );

      let singleData = [];
      favouriteCrypto.map(
        (d, index) =>
          (singleData = [
            ...singleData,
            state.cryptoData.filter((c) => c.id === d)[0],
          ])
      );
      singleData = singleData.filter((m) => m !== undefined);
      dispatch({ type: GET_FAVOURITE_CRYPTO_COINS, payload: singleData });
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getNamesOfDisplayedCryptoData = async (p = 1) => {
    dispatch({ type: GET_NAMES_OF_DISPLAYED_CRYPTO_COINS, payload: p });
  };
  const getSparklines = async (
    coinString,
    interval = "1d",
    localCurrency = state.convt
  ) => {
    // console.log(new Date().getTime() + "getSpark");
    // const currentDate = formatDate(1, timeInChart, interval);
    // const backDate = formatDate(2, timeInChart, interval);
    // console.log(currentDate, backDate);
    // let url = `https://api.nomics.com/v1/currencies/sparkline?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${
    //   coinString ? coinString : "1"
    // }&start=${backDate}&end=${currentDate}&convert=${localCurrency}`;
    // console.log(url);
    try {
      socket.emit("sparkLineData", {
        timeFrame: `${interval}Sparkline`,
        coins: coinString,
        single: true,
      });
      socket.on("sparkLineSingleDataResponse", (sparkdata) => {
        dispatch({
          type: GET_SINGLE_CRYPTO_COINS_SPARKLINES,
          payload: sparkdata,
        });
      });
      // const { data } = await axios.get(url);

      // coinString.length > 8
      //   ? dispatch({ type: GET_CRYPTO_COINS_SPARKLINES, payload: data })
      //   :
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getSparklinesofFavourite = async (
    coinString,
    interval = "1d",
    localCurrency = state.convt
  ) => {
    const currentDate = formatDate(1, timeInChart, interval);
    const backDate = formatDate(2, timeInChart, interval);

    let url = `https://api.nomics.com/v1/currencies/sparkline?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${
      coinString ? coinString : "1"
    }&start=${backDate}&end=${currentDate}&convert=${localCurrency}`;

    try {
      const { data } = await axios.get(url);

      coinString.length > 8
        ? dispatch({
            type: GET_FAVOURITE_CRYPTO_COINS_SPARKLINES,
            payload: data,
          })
        : dispatch({ type: GET_SINGLE_CRYPTO_COINS_SPARKLINES, payload: data });
      return data;
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  // const getCompareCryptoCoinData1Sparkline = async (
  //   coinString,
  //   interval = "All",
  //   localCurrency = state.convt
  // ) => {
  //   console.log(coinString);
  //   console.log(new Date().getTime() + "getSpark");
  //   const currentDate = formatDate(1, timeInChart, interval);
  //   const backDate = formatDate(2, timeInChart, interval);
  //   console.log(currentDate, backDate);
  //   let url = `https://api.nomics.com/v1/currencies/sparkline?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${
  //     coinString ? coinString : "1"
  //   }&start=${backDate}&end=${currentDate}&convert=${localCurrency}`;
  //   console.log(url);
  //   try {
  //     const { data } = await axios.get(url);
  //     dispatch({
  //       type: GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE,
  //       payload: data,
  //     });

  //     return data;
  //   } catch (err) {
  //     dispatch({
  //       type: GET_GLOBAL_TICKER_ERROR,
  //       payload:
  //         err.response && err.response.data.message
  //           ? err.response.data.message
  //           : err.message,
  //     });
  //   }
  // };
  const getCompareCryptoCoinData1Sparkline = async (coin1, coin2) => {
    try {
      socket.emit("sparkLineData", {
        timeFrame: `${timeInChart}Sparkline`,
        coins: `${coin1},${coin2}`,
        single: false,
        compare: true,
      });
      socket.on("sparkLineCompareDataResponse", (sparkdata) => {
        if (sparkdata && sparkdata.length > 0) {
          dispatch({
            type: GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE,
            payload: sparkdata.filter((d) => d.currency === coin1),
          });
          dispatch({
            type: GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE,
            payload: sparkdata.filter((d) => d.currency === coin2),
          });
        }
      });
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

  const getCompareCryptoCoinData2Sparkline = async (
    coinString,
    interval = "All",
    localCurrency = state.convt
  ) => {
    const currentDate = formatDate(1, timeInChart, interval);
    const backDate = formatDate(2, timeInChart, interval);

    let url = `https://api.nomics.com/v1/currencies/sparkline?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&ids=${
      coinString ? coinString : "1"
    }&start=${backDate}&end=${currentDate}&convert=${localCurrency}`;

    try {
      const { data } = await axios.get(url);
      dispatch({
        type: GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE,
        payload: data,
      });

      return data;
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const setCryptostr = (p) => {
    dispatch({ type: SET_CRYPTOSTR, payload: p });
  };
  const clearSparklines = () => {
    dispatch({ type: CLEAR_SPARKLINES });
  };
  const getExchangeRate = async () => {
    dispatch({ type: START_LOADING });
    try {
      socket.emit("exchangeData");
      socket.on("exchangeRateData", (data) => {
        dispatch({
          type: GET_EXCHANGE_RATE,
          payload: data ? JSON.parse(data[state.convt]).rate : 1,
        });
      });

      //place order in vt
    } catch (err) {
      dispatch({
        type: GET_GLOBAL_TICKER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  const sortNormally = () => {
    dispatch({ type: SORT_NORMALLY });
  };
  return (
    <CryptoContext.Provider
      value={{
        getGlobalTicker,
        sortGlobalTickerByPrice,
        sortGlobalTickerBy24h,
        sortGlobalTickerBy7d,
        sortGlobalTickerByName,
        sortGlobalTickerByRank,
        sortGlobalTickerByVolumeIn24h,
        sortGlobalTickerByMarketCap,
        getSingleCryptoDetails,
        clearSingleCryptoDetails,
        searchCoins,
        getAllCryptoCoins,
        getCompareCryptoCoinData2,
        getCompareCryptoCoinData1,
        setConvt,
        getFavouriteCryptoCoins,
        getNamesOfDisplayedCryptoData,
        getSparklines,
        setCryptostr,
        clearSparklines,
        getCompareCryptoCoinData1Sparkline,
        getCompareCryptoCoinData2Sparkline,
        getExchangeRate,
        compareCryptoCoinData1Sparkline: state.compareCryptoCoinData1Sparkline,
        compareCryptoCoinData2Sparkline: state.compareCryptoCoinData2Sparkline,
        singleSparklineData: state.singleSparklineData,
        convt: state.convt,
        cryptoDataError: state.cryptoDataError,
        cryptoData: state.cryptoData,
        order: state.order,
        filter: state.filter,
        filteredCryptoData: state.filteredCryptoData,
        singleCryptoData: state.singleCryptoData,
        loading: state.loading,
        allCoinsData: state.allCoinsData,
        // filteredSearchData: state.filteredSearchData,
        compareCryptoCoinData1: state.compareCryptoCoinData1,
        compareCryptoCoinData2: state.compareCryptoCoinData2,
        cryptoCoinData1: state.cryptoCoinData1,
        cryptoCoinData2: state.cryptoCoinData2,
        headerCoins: state.headerCoins,
        favouriteCryptoCoins: state.favouriteCryptoCoins,
        cryptoStr: state.cryptoStr,
        sparklineData: state.sparklineData,
        singleCryptoPrice: state.singleCryptoPrice,
        livePriceData: state.livePriceData,
        exchangeRate: state.exchangeRate,
        getSparklinesofFavourite,
        favouriteSparklineData: state.favouriteSparklineData,
        currencySymbol: state.currencySymbol,
        sortNormally,
      }}
    >
      {children}
    </CryptoContext.Provider>
  );
};

export default CryptoState;
// const getFavouriteCryptoCoins = async (coinString) => {
//   console.log(coinString + " ........................");
//   try {
//     // const { data } = await axios.get(
//     //   `https://api.nomics.com/v1/currencies/ticker?key=4f124a33438b875c8df1bb38cb8e809f76c45ecb&interval=1d,7d&ids=${
//     //     coinString.length > 0 ? coinString : "1"
//     //   }`
//     // );
//     socket.emit('coinData',{cid:coinString?coinString:"BTC"})
//     socket.on('coinDataResponse',(singleData)=>{
//     console.log("favouriteCryptoCoins " +singleData)
//       dispatch({ type: GET_FAVOURITE_CRYPTO_COINS, payload: singleData });

//     })
//   } catch (err) {
//     dispatch({
//       type: GET_GLOBAL_TICKER_ERROR,
//       payload:
//         err.response && err.response.data.message
//           ? err.response.data.message
//           : err.message,
//     });
//   }
// };
